@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-heading: "Noto Serif SC", "Songti SC", serif;
  --font-body: "Noto Sans SC", "PingFang SC", sans-serif;
  --font-label: "Noto Sans SC", "PingFang SC", sans-serif;

  /* background · 影院暖调黑 */
  --background-50: 0.985 0.002 90;
  --background-100: 0.965 0.003 90;
  --background-200: 0.92 0.004 90;
  --background-300: 0.85 0.005 90;
  --background-400: 0.7 0.006 90;
  --background-500: 0.55 0.007 90;
  --background-600: 0.42 0.008 90;
  --background-700: 0.32 0.009 90;
  --background-800: 0.245 0.01 285;
  --background-900: 0.175 0.011 285;
  --background-950: 0.115 0.012 285;

  /* foreground · 文字与描边 */
  --foreground-50: 0.975 0.004 90;
  --foreground-100: 0.935 0.005 90;
  --foreground-200: 0.865 0.006 90;
  --foreground-300: 0.765 0.007 90;
  --foreground-400: 0.645 0.008 90;
  --foreground-500: 0.525 0.008 90;
  --foreground-600: 0.425 0.009 90;
  --foreground-700: 0.335 0.01 90;
  --foreground-800: 0.255 0.011 90;
  --foreground-900: 0.185 0.012 90;
  --foreground-950: 0.125 0.012 285;

  /* primary · 影院金 */
  --primary-50: 0.972 0.028 88;
  --primary-100: 0.942 0.058 87;
  --primary-200: 0.892 0.098 85;
  --primary-300: 0.832 0.128 82;
  --primary-400: 0.762 0.148 79;
  --primary-500: 0.712 0.158 75;
  --primary-600: 0.632 0.148 70;
  --primary-700: 0.528 0.128 64;
  --primary-800: 0.422 0.1 58;
  --primary-900: 0.322 0.078 52;
  --primary-950: 0.222 0.058 48;

  /* accent · 绯红 */
  --accent-50: 0.962 0.021 15;
  --accent-100: 0.922 0.048 15;
  --accent-200: 0.862 0.082 15;
  --accent-300: 0.782 0.122 16;
  --accent-400: 0.682 0.172 17;
  --accent-500: 0.588 0.198 18;
  --accent-600: 0.505 0.188 18;
  --accent-700: 0.422 0.158 18;
  --accent-800: 0.335 0.122 18;
  --accent-900: 0.255 0.09 18;
  --accent-950: 0.175 0.062 18;

  /* secondary · 夜色青 */
  --secondary-50: 0.962 0.018 180;
  --secondary-100: 0.922 0.03 180;
  --secondary-200: 0.862 0.048 180;
  --secondary-300: 0.782 0.068 180;
  --secondary-400: 0.682 0.08 180;
  --secondary-500: 0.572 0.078 180;
  --secondary-600: 0.482 0.068 180;
  --secondary-700: 0.392 0.058 180;
  --secondary-800: 0.302 0.048 180;
  --secondary-900: 0.232 0.038 180;
  --secondary-950: 0.162 0.028 180;
}

html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  background-color: oklch(var(--background-950));
  color: oklch(var(--foreground-100));
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4 {
  font-family: var(--font-heading);
  letter-spacing: -0.01em;
}

::selection {
  background-color: oklch(var(--primary-500));
  color: oklch(var(--background-950));
}

/* 暗色滚动条 */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: oklch(var(--background-900));
}

::-webkit-scrollbar-thumb {
  background: oklch(var(--foreground-800));
  border-radius: 999px;
}

::-webkit-scrollbar-thumb:hover {
  background: oklch(var(--primary-700));
}

@layer utilities {
  .text-gradient-gold {
    background-image: linear-gradient(
      100deg,
      oklch(var(--primary-200)) 0%,
      oklch(var(--primary-400)) 45%,
      oklch(var(--accent-400)) 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .hero-mask {
    background-image: linear-gradient(
        to right,
        oklch(var(--background-950) / 0.97) 0%,
        oklch(var(--background-950) / 0.82) 38%,
        oklch(var(--background-950) / 0.25) 68%,
        oklch(var(--background-950) / 0.55) 100%
      ),
      linear-gradient(
        to top,
        oklch(var(--background-950)) 4%,
        oklch(var(--background-950) / 0.35) 42%,
        oklch(var(--background-950) / 0.1) 100%
      );
  }

  .card-sheen {
    background-image: linear-gradient(
      160deg,
      oklch(var(--foreground-50) / 0.08) 0%,
      oklch(var(--foreground-50) / 0) 42%
    );
  }

  .no-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }

  .line-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}